import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, NgZone } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { BrandAllocation } from '../../client-core/dtos/brand-allocation.models';
import { BrandService } from '../../client-core/services/brand.service';
import { ValidationMessage } from '../../validation';
import { ChangeDriver, ChangeIndicator } from '../../client-core/dtos/change-driver.model';
import { ProgramService } from '../../client-core/services/program.service';
import { CommunicationRequestDto, CommunicationRequestInfo } from '../../client-core/dtos/communication-request.model';
import { DropzoneComponent } from 'ngx-dropzone-wrapper';
import { ApiService } from 'app/client-core/api.service';
import * as moment from 'moment';
import { NotificationService } from '../utils/notification.service';

@Component({
  selector: 'communication-request-details',
  templateUrl: './communication-request-details.component.html',
  styleUrls: ['./communication-request-details.component.scss']
})
export class CommunicationRequestDetailsComponent implements OnInit, OnChanges {
  @Input() requestId: number;
  @Input() versionId: number;
  ready: boolean;
  validationMessages: any;
  communicationRequestInfo: CommunicationRequestInfo = {} as CommunicationRequestInfo;
  activeTab="info";
  config: any;
  @ViewChild('drpzone') drpzone: DropzoneComponent;
  files: any[] = [];
  loadingImages: boolean;
  
  constructor(
    private layoutService: LayoutService,
    private programService: ProgramService,
    private zone: NgZone,
    private apiService: ApiService,
    private notificationService: NotificationService
  ) {
    const self = this;
    this.config = {
      autoProcessQueue: false,
      acceptedFiles: '*',
      uploadMultiple: true,
      addRemoveLinks: true,
      dictDefaultMessage: 'Click or drop files here',
      init: function() {
        var drop = this;
        this.on('addedfile', function(file) {
          self.zone.run(() => {
            if (!self.files.find(f => f.name == file.name)) {
              console.log(file);
              self.files.push(file);
              console.log(self.files);
            }
          })
        });

        this.on('removedfile', function(file) {
          self.zone.run(() => {
            self.files = drop.files;
            console.log(self.files);
          })
        });
      }
    };
  }

  ngOnInit(): void {
    
  }

  onUploadSuccess() {

  }

  onUploadError() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getCommunicationRequestInfo();
  }

  getCommunicationRequestInfo(updateVersionIdCallOutside: boolean = false) {
    this.programService.getCommunicationRequestInfo(this.requestId).subscribe(res => {
      if (res.data && !res.hasError) {
        this.communicationRequestInfo = res.data;
        if (updateVersionIdCallOutside) {
          this.loadingImages = true;
          setTimeout(() => {
            this.loadingImages = false;
            this.versionId = res.data.currentVersionId;
            this.layoutService.communicationRequestLoadVersion.next(res.data.currentVersionId);
          }, 3000);
        }
      }
      this.ready = true;
    });
  }

  contactsRowSelected(event) {
    if (this.communicationRequestInfo.contacts && !this.communicationRequestInfo.contacts.find(c => c.id == event.item.id)) {
      this.communicationRequestInfo.contacts.push(event.item);
      this.updateContact(event.item.id, 1);
    }
  }

  contactsRemoveRowSelected(event) {
    this.communicationRequestInfo.contacts = this.communicationRequestInfo.contacts.filter(c => c.id != event.id);
    this.updateContact(event.id, 0);
  }

  closeModal() {
    this.layoutService.hideSideModal.next();
  }

  loadVersion(versionid) {
    this.versionId = versionid;
    this.layoutService.communicationRequestLoadVersion.next(versionid);
  }

  updateReasonForReview(reasonForReviewId, isSelected) {
    this.programService.updateReasonForReview({
      requestId: this.requestId,
      reasonForReviewId,
      isSelected: isSelected ? 1 : 0
    }).subscribe(() => {

    })
  }

  updateRelatedTactic(programTacticId, isSelected) {
    this.programService.updateRelatedTactics({
      requestId: this.requestId,
      programTacticId,
      isSelected: isSelected ? 1 : 0
    }).subscribe(() => {
      
    })
  }

  updateContact(contactId, isSelected) {
    this.programService.updateContacts({
      requestId: this.requestId,
      contactId,
      isSelected: isSelected ? 1 : 0
    }).subscribe(() => {
      
    })
  }

  addNewVersion() {
    this.loadingImages = true;
    let fileNames = '';

    if (this.files) {
      fileNames = this.files.map(f => f.name).join(',');
    }

    this.programService.addNewVersion({
      nextVersionId: this.communicationRequestInfo.nextVersionId,
      fileNames,
      requestId: this.communicationRequestInfo.id
    }).subscribe(res => {
      let promisses = [];
      let addedPromisses = [];
      this.files.forEach(file => {
        if (!addedPromisses.find(f => f == file.name)) {
          addedPromisses.push(file.name);
          promisses.push(this.apiService.uploadCommunicationRequestFile(file, this.communicationRequestInfo.programInfo[0].programId, this.communicationRequestInfo.id, this.communicationRequestInfo.nextVersionId));
        }
      });
      Promise.all(promisses).then(filesRes => {
        this.files = [];
        this.drpzone.directiveRef.reset();
        
        setTimeout(() => {
          this.getCommunicationRequestInfo(true);
          this.loadVersion(this.communicationRequestInfo.nextVersionId);
          this.loadingImages = false;
        }, 1000);
        
      });
    })
  }

  markAsResolved() {
    this.notificationService.smartMessageBox({
      title: "",
      content: `Are you sure you want mark this request as approved?`,
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
        if (ButtonPressed == "Yes") {
          this.programService.markCommunicationAsResolved({
            action: 'Resolved',
            requestId: this.requestId
          }).subscribe(() => {
            this.getCommunicationRequestInfo();
          })
        }
    });
  }

  reopen() {
    this.notificationService.smartMessageBox({
      title: "",
      content: `Are you sure you want to reopen this request?`,
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
        if (ButtonPressed == "Yes") {
          this.programService.markCommunicationAsResolved({
            action: 'Reopen',
            requestId: this.requestId
          }).subscribe(() => {
            this.getCommunicationRequestInfo();
          })
        }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/communication-request-details/communication-request-details.component.ts